import { API, graphqlOperation } from 'aws-amplify';
import { updateCampaign, deleteCampaign } from 'src/graphql/mutations';
import { getCampaign } from 'src/graphql/queries';
import { CreateCampaignDash } from 'src/graphql/customized_mutations';
import axios from 'axios';
import { listCampaigns_Dash } from 'src/graphql/customized_queries';
import { environment, url } from 'src/environments';

export const createNewCampaignAPI = async (input) => {
  try {
    const { data } = await API.graphql({
      query: CreateCampaignDash,
      variables: {
        input
      }
    });
    // return data;
    try {
      const tiie = await axios.get(`${url}/${environment}/admin/get-tiie`);
    } catch (error) {
      console.error(error);
    }
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getSpecificCampaign = async (id) => {
  const rawResponse = await API.graphql(graphqlOperation(getCampaign, { id }));
  return rawResponse.data.getCampaign;
};

export const updateExistentCampaign = async (input) => {
  const rawResponse = await API.graphql(graphqlOperation(updateCampaign, { input }));
  return rawResponse.data.updateCampaign;
};

export const getlistCampaigns = async (id) => {
  const rawResponse = await API.graphql(graphqlOperation(listCampaigns_Dash, { id }));
  return rawResponse.data.listCampaigns;
};

export const deleteSpecificCampaign = async (input) => {
  const rawResponse = await API.graphql(graphqlOperation(deleteCampaign, { input }));
  return rawResponse.data.deleteCampaign;
};
